/* eslint-disable @next/next/no-head-element */
/* eslint-disable @next/next/no-page-custom-font */
import { ReactNode } from 'react';
import { openSans } from '@/components/dc/fonts';
import { SessionProvider } from 'next-auth/react';

import HeaderDC from '../HeaderDC';
import SkipLink, { MAIN_CONTENT_ID } from '@/components/common/skip-link';
import FooterDC from '../FooterDC';

import '../../../app/globals.css';
import './DefaultLayoutDC.css';

interface LayoutProps {
  children: ReactNode;
}

const DefaultLayoutDC = async ({ children }: LayoutProps) => {
  return (
    <html lang="en" className={openSans.variable}>
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </head>
      <body className="body-dc">
        <SessionProvider session={null}>
          <link rel="shortcut icon" href="/dc/favicon.ico" />
          <div className="h-full flex flex-col justify-between">
            <div>
              <SkipLink />
              <HeaderDC />
              <main id={MAIN_CONTENT_ID} tabIndex={-1} className="outline-none">
                {children}
              </main>
            </div>
            <div>
              <div className="h-2 min-h-2 bg-dc-vermilion" />
              <FooterDC isAuthorized={false} />
            </div>
          </div>
        </SessionProvider>
      </body>
    </html>
  );
};

export default DefaultLayoutDC;
